<template>
    <v-app-bar app color="primary" dark>
      <v-toolbar-title>
        <router-link to="/" style="color: white; text-decoration: none;">
          Haikubox Groups
        </router-link>
      </v-toolbar-title>
      
      <v-spacer></v-spacer>
      
      <v-btn text @click="$emit('signIn')">
        Sign In
      </v-btn>
      
      <v-btn text @click="$emit('signUp')">
        Sign Up
      </v-btn>
    </v-app-bar>
  </template>
  
  <script>
  export default {
    name: "PublicHeader"
  };
  </script>